export default "__VITE_ASSET__9110c7de__"